export default __webpack_public_path__ + "static/media/0005.75a045dc.png";